import { useLanguage } from "@/LanguageContext";
import { motion } from "framer-motion";

export default function MethodSection() {
  const { t } = useLanguage();
  const steps = t("method.steps");

  return (
    <section
      id="method"
      data-testid="method-section"
      className="py-24 lg:py-32 bg-[#F0EBE3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <p className="text-sm font-body uppercase tracking-[0.2em] text-[#6FA8B6] mb-4">
            {t("method.label")}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2C3E50]">
            {t("method.title")}
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-px bg-[#6FA8B6]/20" />

          {Array.isArray(steps) &&
            steps.map((step, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
                className="text-center relative"
                data-testid={`method-step-${i}`}
              >
                <div className="w-20 h-20 mx-auto mb-8 bg-[#F7F3EE] rounded-full border-2 border-[#6FA8B6]/20 flex items-center justify-center shadow-sm relative z-10">
                  <span className="font-heading text-2xl text-[#6FA8B6]">
                    {step.number}
                  </span>
                </div>
                <h3 className="font-heading text-2xl text-[#2C3E50] mb-4">
                  {step.title}
                </h3>
                <p className="font-body text-sm text-[#2C3E50]/60 leading-relaxed max-w-xs mx-auto">
                  {step.description}
                </p>
              </motion.div>
            ))}
        </div>
      </div>
    </section>
  );
}
